import { render } from "./AlarmcodesOrganisation.vue?vue&type=template&id=5d505c93"
import script from "./AlarmcodesOrganisation.vue?vue&type=script&lang=js"
export * from "./AlarmcodesOrganisation.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__